<template>
    <div class="FieldHelpWrap">
        <div class="FieldHelpWrap__input">
            <STextArea
                :name="name"
                :input-data="paragraphText"
                :namespace="fieldNamespace"
                :key="fieldNamespace"
            />
        </div>
        <div
            class="FieldHelpWrap__help"
            v-if="helpText"
        >
            <HelpModal
                v-if="helpText"
                :text="helpText"
                :title="helpTitle"
            />
        </div>
    </div>
</template>

<script>
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';
import STextArea from '@/views/Common/Input/STextArea';

export default {

    components: {
        STextArea,
    },
    mixins: [ SubmissionBoilerplate ],

    data() {
        return {
            paragraphText: '',
        };
    },

    methods: {
        loadFieldData() {
            if (this.submission && this.submission.paragraphText) {
                this.paragraphText = this.submission.paragraphText;
            } else if (this.population && this.population.paragraphText) {
                this.paragraphText = this.population.paragraphText;
            }
            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                paragraphText: this.paragraphText
            };

            this.storeFieldData();
        }
    }
};
</script>
